export default __webpack_public_path__ + "static/media/product-10.c4bcc249.webp";